import React, { useState } from 'react'
import { FaDiscord, FaFacebookF, FaInstagram, FaTiktok, FaTumblr, FaTwitter, FaYoutube, } from 'react-icons/fa'
import { FaTwitch } from 'react-icons/fa6'
import SocialMobileLink from './SocialMobileLink'
import './socialmobile.css'
import useAppContext from '../../hook/useAppContext'

const SocialMobile = () => {

      const [mobile, setMobile] = useState(false)

      const {user} = useAppContext()
      const {social} = user 

      if(social.code) return 
      
      const showSocialMobile = () => {
            setMobile(!mobile)
      }

      

      return (
            <div className="social_mobile flex">
                  <button className={mobile ? "btn_toogle_social active" : "btn_toogle_social"} onClick={() => showSocialMobile()}>
                        <span></span>
                        <span></span>
                        <span></span>
                  </button>
                  <div className={mobile ? "social_mobile__items active flex" : "social_mobile__items flex"}>
                        <SocialMobileLink link={social.facebook} classObj={`facebook`} icon={<FaFacebookF />} />
                        <SocialMobileLink link={social.twitter} classObj={`twitter`} icon={<FaTwitter />} />
                        <SocialMobileLink link={social.instagram} classObj={`instagram`} icon={<FaInstagram />} />
                        <SocialMobileLink link={social.youtube} classObj={`youtube`} icon={<FaYoutube />} />
                        <SocialMobileLink link={social.tiktok} classObj={`tiktok`} icon={<FaTiktok />} />
                        <SocialMobileLink link={social.tumblr} classObj={`tumblr`} icon={<FaTumblr />} />
                        <SocialMobileLink link={social.discord} classObj={`discord`} icon={<FaDiscord />} />
                        <SocialMobileLink link={social.twitch} classObj={`twitch`} icon={<FaTwitch />} />
                  </div>
                  
            </div>
      )
}

export default SocialMobile
